import carousel from 'edge/platform/widgets/carousel/directives/GwCarousel';
import 'edge/platform/widgets/carousel/ui-bootstrap-carousel/ui-bootstrap-carousel';

export default angular.module('edge.platform.widgets.carousel', [
    'ui.bootstrap.carousel'
])
    .directive('gwCarousel', carousel);